// eslint-disable-next-line import/prefer-default-export
export const COUNTRIES = {
  us: 'UNITED_STATES',
  ca: 'CANADA',
  uk: 'GREAT_BRITAIN',
};
